import { ResourceCountChip } from './ResourceCountChip';

export interface FolderHeadingProps {
  name: string;
  description: string | null;
  itemCount: number;
}

/**
 * Folder page body heading (FR-154): large centred title, the description (left
 * out entirely when absent, so it leaves no gap) and the count chip. An `<h2>`:
 * `PageHeader` already renders the folder name as the page's one (sr-only) `<h1>`.
 */
export function FolderHeading({ name, description, itemCount }: FolderHeadingProps) {
  const text = description?.trim();

  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <h2 className="text-h2 text-navy">{name}</h2>
      {text && <p className="max-w-2xl text-sm text-body">{text}</p>}
      <ResourceCountChip count={itemCount} />
    </div>
  );
}
